import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Box, Typography } from '@material-ui/core'
import { useStyles } from './StudentRegister_style'

import ExperienceProfile from 'pages/user/Profile/StudentProfile/Components/ExperienceProfile/ExperienceProfile'
import ProfileSimpleInfo from '../../../user/Profile/StudentProfile/Components/ProfileSimpleInfo/ProfileSimpleInfo'
import ProgressCircle from 'components/ProgressCircle/ProgressCircle'
import Button from 'shared/components/Button/Button'
import IconFactory from '../../../../shared/icons/IconFactory/IconFactory'

const ManualRegister = (props) => {
    const {
        handleNext,
        handleManualCreation,
        student,
        setStudent,
        studentFormation,
        setStudentFormation,
        loading
    } = props

    const classes = useStyles()

    const renderStudentInformation = () => {
        return (
            <ProfileSimpleInfo
                student={student}
                setStudent={setStudent}
            />
        )
    }

    const renderExperiences = () => {
        return (
            <ExperienceProfile
                setExperienceIsUpdated={() => { }}
                studentFormation={studentFormation}
                setStudentFormation={setStudentFormation}
                disabledSave
                disabledPaper
                condensed
                withCondensedStyle
            />
        )
    }

    return (
        <Box className={classes.studentRegisterViewContainer}>
            {loading ? (
                <Box className={classes.progressCircleContainer}>
                    <ProgressCircle />
                </Box>
            ) : (
                <form onSubmit={handleNext} className={classes.form}>
                    <Box className={classes.formTitle}>
                        <FormattedMessage id="landing_login_page.sign_up.title" />
                        <Button className={classes.automaticComplete} onClick={handleManualCreation}>
                            <FormattedMessage id="landing_login_page.sign_up.ai.automatic_profile_completion" />
                            <IconFactory icon="AI" className={classes.aiIcon} />
                        </Button>
                    </Box>
                    {renderStudentInformation()}
                    {renderExperiences()}
                    <Button className={classes.submitButton} type="submit">
                        <FormattedMessage id="landing_login_page.confirm" />
                    </Button>
                </form>
            )}
        </Box>
    )
}

export default ManualRegister
